export const initialCustomerState = {
    customers: [],
    customer: null,
    status: 'idle',
    error: null,
  };
  